import { styled } from 'styled-components';

import WarningIcon from '../../../assets/icons/status-warning.svg?react';

const TableSC = styled.table`
  width: 100%;
  border-spacing: 0;

  tr:first-child th {
    border-radius: 0.125rem 0 0 0;
  }
  tr:first-child td {
    border-radius: 0 0.125rem 0 0;
  }

  tr:last-child th {
    border-radius: 0 0 0 0.125rem;
  }
  tr:last-child td {
    border-radius: 0 0 0.125rem 0;
  }
`;

const TableRow = styled.tr`
  padding: 1.0625rem 1rem;
  vertical-align: baseline;

  &:nth-child(odd) {
    background: ${(props) => props.theme.colors.slateGray[10]};
  }
  &:nth-child(even) {
    background: ${(props) => props.theme.colors.white};
  }
`;

const TableHeaderCell = styled.th`
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1rem;
  padding: 1.0625rem 1rem;
  width: 50%;
  text-align: start;
`;

const TableCell = styled.td`
  padding: 1.0625rem 1rem;
  font-size: 0.875rem;
  line-height: 1.375rem;
`;

const CellWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: ${(props) => props.theme.devices.mobileL}) {
    justify-content: flex-end;
  }

  svg {
    vertical-align: middle;
    height: 1rem;
  }
`;

const ValueCell = styled.div<{ $isEmpty?: boolean }>`
  color: ${(props) => (props.$isEmpty ? props.theme.colors.oxfordBlue[30] : 'inherit')};

  @media (max-width: ${(props) => props.theme.devices.mobileL}) {
    text-align: ${(props) => (props.theme.isRtl ? 'left' : 'right')};
  }
`;

const IconContainer = styled.div`
  margin-inline-start: 2rem;
  color: ${(props) => props.theme.colors.alertRed[100]};

  @media (max-width: ${(props) => props.theme.devices.mobileL}) {
    margin-inline-start: 0.375rem;
  }
`;

export type TableData = {
  id: string;
  label?: string;
  value?: string;
};

type TableProps = {
  'data-test-id'?: string;
  emptyCellLabel?: string;
  tableData: TableData[];
};

export const StripedTable = ({ 'data-test-id': dataTestId, emptyCellLabel = 'Not found', tableData }: TableProps) => {
  return (
    <TableSC data-test-id={dataTestId}>
      <tbody>
        {tableData.map((row) => (
          <TableRow key={row.id}>
            <TableHeaderCell scope="row">{row.label}</TableHeaderCell>
            <TableCell>
              <CellWrapper>
                {row.value ? (
                  <ValueCell>{row.value}</ValueCell>
                ) : (
                  <>
                    <ValueCell $isEmpty>{emptyCellLabel}</ValueCell>
                    <IconContainer>
                      <WarningIcon />
                    </IconContainer>
                  </>
                )}
              </CellWrapper>
            </TableCell>
          </TableRow>
        ))}
      </tbody>
    </TableSC>
  );
};
